import {
  KeystoneApiClient,
  type KeystoneResult,
} from "data/keystone-api-client";
import { SSError } from "data/ss-error";

export type KeystonePolicySearchResultAddress = {
  firstName: string;
  lastName: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  zipPlus4: string;
  addressType: string; // better?
};

export type KeystonePolicySearchResult = {
  addresses: KeystonePolicySearchResultAddress[];
  carrier: string;
  carrierId: string;
  keystonePolicyId: string;
  platformPolicyId: string;
  policyState: string;
  quoteNumber: string;
  isCommercial: boolean;
  policyType: string;
};

class KeystoneAdminClient extends KeystoneApiClient {
  searchPolicies = async (
    input: string,
  ): Promise<
    KeystoneResult<{ count: number; results: KeystonePolicySearchResult[] }>
  > => {
    const encoded = encodeURIComponent(input);
    const apiRes = await this.get<{
      count: number;
      searchResults: KeystonePolicySearchResult[];
    }>(`/api/policy/search/${encoded}`);
    if (apiRes instanceof SSError) {
      return apiRes;
    }
    return { count: apiRes.count, results: apiRes.searchResults };
  };
}

export const ADMIN_KEYSTONE = new KeystoneAdminClient();
